/** Each website reads only its own blog dataset. */
export const BLOG_SITE = "universemeta";
